module.exports = __webpack_public_path__ + "public/images/stand-bg-general.f6d1f35dd37ef7d53d503c63bb484bad.png";